<template>
  <div><slot></slot></div>
</template>

<script>
import Components from "../../index";
export default {
  name: "PsColumnGroup",
   data() {
    return {
      theTableRef: "",
      theFormatter: null,
      theFormatterStringOptions: []
    };
  },
  props: {
    tableRef: "",
    title: { type: String, default: "" },
    formatter: {type: Function|String, default: null },
    formatterParams: {type: Object, default: function () {
      return {}
    }},
    field: String,
    titleFormatter: {
      type: Function,
      default: (cell, formatterParams, onRendered) => {
        var title = cell.getValue();
        var el = cell.getElement();
        if (typeof(formatterParams.tooltip) != "undefined" && typeof(formatterParams.tooltiptext) != "undefined"){
          title += " <span id='" + formatterParams.tooltip + "ToolTip' class='psTooltip'></span>";
          window.Bus.$emit("TooltipAdded", { id: formatterParams.tooltip + "ToolTip", text: formatterParams.tooltiptext });
        } 
        return title;    
    }
    },  
    printFormatter: {
      type:Boolean|Function,
      default:null
    },
    tooltip: "",
    cssClass: String,
    hozAlign: String,
    headerSort: Boolean,
    print: {type: Boolean, default: true},
    headerClick: Function,
    cellClick: Function,
    editor: {
      type: Function,
      default: (cell, onRendered, success, cancel, editorParams) => {
        var cellValue = cell.getValue(),
          input = document.createElement("input");

        input.setAttribute("type", editorParams.search ? "search" : "text");
        input.style.width = "100%";
        input.style.height = "100%";
        input.style.borderRadius = "2";
        input.style.outline = "none";
        input.style.backgroundColor = "#cccccc";
        if (
          editorParams.elementAttributes &&
          typeof editorParams.elementAttributes == "object"
        ) {
          for (let key in editorParams.elementAttributes) {
            if (key.charAt(0) == "+") {
              key = key.slice(1);
              input.setAttribute(
                key,
                input.getAttribute(key) +
                  editorParams.elementAttributes["+" + key]
              );
            } else {
              input.setAttribute(key, editorParams.elementAttributes[key]);
            }
          }
        }

        input.value = typeof cellValue !== "undefined" ? cellValue : "";

        onRendered(function () {
          input.focus();
          input.select();
          input.style.height = "100%";
        });

        function onChange(e) {
          if (
            ((cellValue === null || typeof cellValue === "undefined") &&
              input.value !== "") ||
            input.value != cellValue
          ) {
            if (success(input.value)) {
              cellValue = input.value; //persist value if successfully validated in case editor is used as header filter
            }
          } else {
            cancel();
          }
        }

        //submit new value on blur or change
        input.addEventListener("change", onChange);
        input.addEventListener("blur", onChange);

        //submit new value on enter
        input.addEventListener("keydown", function (e) {
          switch (e.keyCode) {
            case 13:
              onChange(e);
              break;

            case 27:
              cancel();
              break;
          }
        });

        return input;
      },
    },
  },
  inject: ["getTabulatorReference"],
  created: function () { },
  mounted() {
    this.theTableRef = this.getTabulatorReference;
    var parentCols = [];
    this.$children.forEach(c => {
		if(c.$vnode.componentOptions.tag === "ps-row-copier" || c.$vnode.componentOptions.tag === 'ps-actions')
	      return;

        var obj = {};
        obj.props = c._props;
        obj.props.sorter = "string";
        obj.props.titleFormatterParams =  {"tooltip": c._props.field + this.theTableRef, "tooltiptext": c._props.tooltip };
       
      if (c.$children.length > 0){
        var childFormatterData = {
          components: []
        };

        c.$children.forEach(c1 => {
          var aTag = c1.$vnode.tag.split('-');
          var tag = aTag[aTag.length - 1];

          var ComponentClass = Vue.extend(Components.components[tag]);
          childFormatterData['components'].push({props: c1._props, instance: ComponentClass});
        });

      obj.props.formatter = 'renderChildComponents';
      obj.props.formatterParams = childFormatterData;
    }

       obj.tableRef = this.theTableRef;
        parentCols.push(obj.props);
    });
  
    var pObj = {};
    pObj.props = {};
    Object.assign(pObj.props, this.$props);

    pObj.props.columns = parentCols;
    pObj.tableRef = this.theTableRef;

    if (this.$props.printFormatter != null){
      pObj.props.formatterPrint = this.$props.printFormatter;
    }

    window.Bus.$emit("NewColumnAdded", pObj);
  },
  methods: {
    setFormatter() {
      if(this.formatterString !== "")
      {
        this.theFormatter = this[this.formatterString];
      }
    },    
    rowSelected: (row) => {
      this.setRowDeleteCondition(row);
    },
    rowDeselected: (row) => {
      this.setRowUnDeleteCondition(row);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
